import { userManagementService } from "../request";

/**
 * 获取组织架构树
 * @returns {Promise} 返回Promise对象
 */
export const getOrgTree = () => {
  return userManagementService.get("/departments/tree");
};

/**
 * 获取旗县列表
 * @param {Object} params 查询参数 {page, size, name?, status?}
 * @returns {Promise} 返回Promise对象
 */
export const getDepartments = (params) => {
  return userManagementService.get("/departments", { params });
};

/**
 * 创建旗县
 * @param {Object} data 旗县数据
 * @returns {Promise} 返回Promise对象
 */
export const createDepartment = (data) => {
  return userManagementService.post("/departments", data);
};

/**
 * 更新旗县信息
 * @param {String} id 旗县ID
 * @param {Object} data 更新数据
 * @returns {Promise} 返回Promise对象
 */
export const updateDepartment = (id, data) => {
  return userManagementService.put(`/departments/${id}`, data);
};

/**
 * 删除旗县
 * @param {String} id 旗县ID
 * @returns {Promise} 返回Promise对象
 */
export const deleteDepartment = (id) => {
  return userManagementService.delete(`/departments/${id}`);
};

/**
 * 获取完整的组织结构（包括旗县和用户）
 */
export const getDepartmentStructure = (params) => {
  return userManagementService.get("/departments/structure", { params });
}
